// extracted by mini-css-extract-plugin
export default {"root":"RecipeProcess_root__UcOAT","delete-icon":"RecipeProcess_delete-icon__sT-3j","move-icon":"RecipeProcess_move-icon__yYW2r"};